<template>
  <div class="wind-farm-left-box">
    <div class="left-box-father" @click="handleTitleClick">
      <i
        :class="[
          'icon',
          {
            'el-icon-arrow-down': isShow,
            'el-icon-arrow-right': !isShow
          }
        ]"
      ></i>
      <span class="header" v-if="!isEdit">
        {{ header }}
      </span>
      <span v-else>
        <input
          class="sp stand-input"
          type="text"
          v-model="header"
          @click.stop="() => {}"
        />
      </span>
      <div v-if="useEdit" class="right-box">
        <i class="el-icon-download ic" @click.stop="handleDownLoad"></i>
        <icon :url="moneyIcon" @click="handleClickFinance" />
        <!-- <i class="el-icon-money ic"></i> -->
        <template v-if="!isEdit">
          <i class="el-icon-edit ic" @click.stop="handleEditClick"></i>
          <i class="el-icon-delete ic" @click.stop="handleDel"></i>
        </template>
        <template v-else>
          <i class="el-icon-check ic" @click.stop="handleCheck"></i>
          <i class="el-icon-close ic" @click.stop="handleCancelClick"></i>
        </template>
      </div>
    </div>
    <div v-show="isShow" class="children-pad">
      <slot></slot>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    useEdit: {
      type: Boolean,
      default: false
    },
    header: {
      type: String,
      default: '-'
    },
    useModel: {
      type: Boolean,
      default: false
    },
    showContent: {
      type: Boolean,
      default: false
    },
    isEditWindFarm: {
      type: Boolean,
      default: false
    },
    precondition: {
      type: Function,
      default: () => true
    }
  },
  data() {
    return {
      isShow: true,
      myHeader: '',
      isEdit: false,
      storeName: '',
      moneyIcon: require('@/asset/money.svg')
    };
  },

  watch: {
    isEditWindFarm: {
      handler(val) {
        this.isEdit = val;
      },
      immediate: true
    },
    isEdit: {
      handler(val) {
        this.$emit('update:isEditWindFarm', val);
      }
    },
    myHeader: {
      handler(val) {
        this.$emit('update:header', val);
      }
    },
    header: {
      handler(val) {
        this.myHeader = val;
      },
      deep: true
    },
    showContent: {
      handler(val) {
        if (this.useModel) {
          this.isShow = val;
        }
      },
      immediate: true
    },
    isShow: {
      handler(val) {
        if (this.useModel) {
          this.$emit('update:showContent', val);
        }
      }
    }
  },
  methods: {
    handleDownLoad() {
      this.$emit('downClick');
    },
    handleEditClick() {
      this.storeName = this.myHeader;
      this.isEdit = true;
      this.$emit('editClick');
    },
    handleBtnClick() {
      this.$emit('close');
    },
    handleCancelClick() {
      this.myHeader = this.storeName;
      this.isEdit = false;
      this.$emit('cancel');
    },
    handleCheck() {
      this.$emit('check');
    },
    handleDel() {
      this.$emit('del');
    },
    handleTitleClick() {
      if (this.precondition()) {
        this.isShow = !this.isShow;
        this.$emit('titleClick', this.isShow);
      }
    },
    handleClickFinance() {
      this.$emit('financeClick');
    }
  }
};
</script>

<style lang="less" scoped>
.left-box-father {
  position: relative;
  height: 40px;
  display: flex;
  align-items: center;
  color: #fff;
  font-size: 14px;
  border-bottom: 1px #999 solid;
  cursor: pointer;
  position: relative;
  background-color: #0159ac;
  user-select: none;
  .close-icon {
    position: absolute;
    right: 10px;
    &:hover {
      color: #999;
    }
  }
  .icon {
    margin: 0px 5px;
  }
  .ic {
    margin: 0px 2px;
    &:hover {
      color: #478beb;
    }
  }
  .right-box {
    position: absolute;
    right: 10px;
  }
  .header {
    height: 30px;
    line-height: 30px;
    width: 105px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
  .sp {
    width: 105px !important;
    height: 24px;
  }
}
.child-item {
  color: #fff;
}
</style>
